import React from 'react';

/**
 * Surfaces render errors in the UI and always logs to the console (no silent white/black screen).
 */
export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[flowcore:react]', error);
    if (info?.componentStack) {
      console.error('[flowcore:react] component stack', info.componentStack);
    }
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            padding: 24,
            background: '#09090b',
            color: '#e4e4e7',
            fontFamily: 'system-ui, Segoe UI, sans-serif',
            fontSize: 14
          }}
        >
          <h1 style={{ fontSize: 18, marginBottom: 12 }}>Application error</h1>
          <p style={{ color: '#a1a1aa', marginBottom: 16 }}>
            See the browser console for <code>[flowcore:react]</code>.
          </p>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              padding: 12,
              background: '#18181b',
              borderRadius: 8,
              border: '1px solid #27272a'
            }}
          >
            {error.message || String(error)}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 16,
              padding: '8px 14px',
              borderRadius: 8,
              border: '1px solid #52525b',
              background: '#27272a',
              color: '#fafafa',
              cursor: 'pointer'
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
